<template>
  <DialogTemplate
    :show-controls="true"
    :close-click-outside="false"
    class="dialog-friends-challenge"
    @close="close(false)"
  >
    <div class="friends-challenge">
      <h4 class="title">Boost ta motivation avec tes potes !</h4>
      <img
        src="~/assets/images/friends-challenge.webp"
        srcset="~/assets/images/friends-challenge@2x.webp 2x"
        width="264"
        height="200"
      />
      <p class="description">
        Ajoute tes amis dès maintenant pour réviser ensemble, vous soutenir et
        relever des défis sur les quiz ! C’est plus fun à plusieurs !
      </p>
      <div class="actions">
        <ButtonBase
          variant="tonal"
          theme="secondary"
          stroke="n"
          class="button"
          rounded
          size="small"
          to="/mes-amis/decouverte"
          @click="close(true)"
        >
          Retrouve tes potes
        </ButtonBase>
        <ButtonUnderline @click="close(false)">Plus tard</ButtonUnderline>
      </div>
    </div>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import { EventFriend } from '~/types/adamTypes';

const emit = defineEmits(["close"]);

useAppEventFriend().send(EventFriend.FriendHomePopupViewed);

const close = (accepted: boolean) => {
  if (accepted) {
    useAppEventFriend().send(EventFriend.FriendHomePopupOpenClicked);
  } else {
    useAppEventFriend().send(EventFriend.FriendHomePopupCloseClicked);
  }
  emit('close');
};
</script>
<style lang="scss" scoped>
.dialog-friends-challenge {
  max-width: auto;
  background-color: var(--color_neutral_25);
}
.friends-challenge {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
  align-items: center;
}
.actions {
  display: flex;
  flex-direction: column;
  gap: var(--gap_n);
  align-items: center;
}
.description {
  @include font('m', 400, 'seoncdary');

  text-align: center;
}
</style>
